export default __webpack_public_path__ + "static/media/DSC_0521.3e0e0933.webp";